var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-panel mt-5"},[_c('product-form',{on:{"on-submit":_vm.save}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }